import { render, staticRenderFns } from "./OCRValidation.vue?vue&type=template&id=3c890ac0&scoped=true&"
import script from "./OCRValidation.vue?vue&type=script&lang=js&"
export * from "./OCRValidation.vue?vue&type=script&lang=js&"
import style0 from "./OCRValidation.vue?vue&type=style&index=0&id=3c890ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c890ac0",
  null
  
)

export default component.exports